import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  NAME_INPUT: `${cleanedFilename(__filename)}-name-input`,
  FORM: `${cleanedFilename(__filename)}-form`,
  NEXT_BUTTON: `${cleanedFilename(__filename)}-next-button`,
};
